import { db } from '../config/firebase';
import { doc, getDoc } from 'firebase/firestore';

// Bug A (T19, Prompt #520): getWorkerContactDetails returns permission-denied
// once the employer/worker relationship no longer qualifies. The applicant's
// name is still public via the publicWorkerProfiles/{uid} projection (the same
// one Dashboard/I9Schedule/OfferLetters read), so the applicants pages fall
// back to it for the NAME only. Contact details (email) stay denied, and
// users/{uid} is never read.
export const isPermissionDenied = (error) =>
  error?.code === 'functions/permission-denied' || error?.code === 'permission-denied';

// displayName from the public projection, or null when the projection is
// missing, the name is empty, or the read fails.
export const fetchPublicWorkerName = async (uid) => {
  try {
    const snap = await getDoc(doc(db, 'publicWorkerProfiles', uid));
    if (!snap.exists()) return null;
    const name = snap.data().displayName;
    return typeof name === 'string' && name.trim() ? name : null;
  } catch (_) {
    return null;
  }
};
